import React, { useEffect, useState } from 'react';

import useUsers from '../../context/UsersContext';
import useConfig from '../../context/ConfigContext';

import { Box } from '@mui/material';
import { sxConfig } from '../ProductionGeneratorPartial/ProductionGeneratorPartial.style';
import ProductionGeneratorPartialTable from '../ProductionGeneratorPartial/ProductionGeneratorPartialTable';
import ProductionGeneratorPartialVariantTree from './ProductionGeneratorPartialVariantTree';
import ProductionGeneratorPartialNewProdTable from '../ProductionGeneratorPartial/ProductionGeneratorPartialNewProdTable';
import { useLoader } from '../../provider/LoaderProvider';
import prodgeneratorPartialService from '../../service/prodgeneratorPartial.service';

const ProductionGeneratorPartialVariantPage = () => {
  const { getUser, user } = useUsers();
  const { config, getConfig } = useConfig();
  const { showLoader, hideLoader } = useLoader();

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [removedItem, setRemovedItem] = useState(null);
  const [refetchTable, setRefetchTable] = useState(false);
  const [sourceData, setSourceData] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [expandedItems, setExpandedItems] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [newProds, setNewProds] = useState([]);
  const [prodsAndFromWhs, setProdsAndFromWhs] = useState([]);

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(config).length) getConfig();
  }, []);

  const getTreeData = (itemCode) => {
    showLoader();
    prodgeneratorPartialService
      .getsourcelistByItemCode({ itemCode })
      .then((data) => {
        setTreeData(data.treeView);
        setSourceData(data.sourceData);
        setExpandedItems(getAllItemIds(data.treeView));
      })
      .finally(() => {
        hideLoader();
      });
  };

  const getAllItemIds = (items, ids = []) => {
    if (!items.length) return ids;
    items.forEach((item) => {
      ids.push(item.id);
      if (item.children) getAllItemIds(item.children, ids);
    });
    return ids;
  };

  const getProdsAndFromWhs = (body) => {
    prodgeneratorPartialService.getDetails(body).then((data) => {
      setProdsAndFromWhs(data);
    });
  };

  return (
    <Box sx={sxConfig.containerBox}>
      <Box sx={sxConfig.formBox}>
        <ProductionGeneratorPartialTable
          refetchState={{ refetchTable, setRefetchTable }}
          selectedOrderState={{ selectedOrder, setSelectedOrder }}
          getTreeData={getTreeData}
          getProdsAndFromWhs={getProdsAndFromWhs}
        />
        <ProductionGeneratorPartialVariantTree
          sourceDataState={{ sourceData, setSourceData }}
          treeDataState={{ treeData, setTreeData }}
          expandedItemsState={{ expandedItems, setExpandedItems }}
          selectedItemState={{ selectedItem, setSelectedItem }}
          removedItemState={{ removedItem, setRemovedItem }}
          selectedOrderState={{ selectedOrder, setSelectedOrder }}
          newProdsState={{ newProds, setNewProds }}
          prodsAndFromWhsState={{ prodsAndFromWhs, setProdsAndFromWhs }}
        />
        <ProductionGeneratorPartialNewProdTable
          removedItemState={{ removedItem, setRemovedItem }}
          refetchState={{ refetchTable, setRefetchTable }}
          selectedItemState={{ selectedItem, setSelectedItem }}
          selectedRowsState={{ selectedRows, setSelectedRows }}
          selectedOrderState={{ selectedOrder, setSelectedOrder }}
          getTreeData={getTreeData}
          newProdsState={{ newProds, setNewProds }}
          getProdsAndFromWhs={getProdsAndFromWhs}
        />
      </Box>
    </Box>
  );
};

export default ProductionGeneratorPartialVariantPage;
